const translations = {
  placeholder: "Find a member to chat with"
};

export default translations;
